import * as t from './actionTypes';
import common from '../../common';

export function setLoading(loading) {
    return {
        type: t.SET_LOADING,
        payload: loading
    };
}

export function loadItems() {
    return async (dispatch, getState) => {
        dispatch({
            type: t.SET_LOADING,
            payload: true
        })

        const resp = await common.apiClient.get(`${common.SETTINGS.REMOTERESOURCES.API.ROOT_URL}/api/KYC`);
        dispatch({
            type: t.LOAD_ITEMS,
            payload: resp.data
        });
        dispatch({
            type: t.SET_LOADING,
            payload: false
        });
    };
}
